import { useState, useEffect } from 'react';
import "./Project.css";
import projectsData from "./projectsData";

const Project = () => {
    const [activeCategory, setActiveCategory] = useState('all');
    const [filteredProjects, setFilteredProjects] = useState(projectsData);
    const [selectedProject, setSelectedProject] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    useEffect(() => {
        if (activeCategory === 'all') {
            setFilteredProjects(projectsData);
        } else {
            setFilteredProjects(projectsData.filter(project => project.category === activeCategory));
        }
    }, [activeCategory]);

    const openModal = (project) => {
        setSelectedProject(project);
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedProject(null);
        document.body.style.overflow = 'unset';
    };

    return (
        <section className="project__section" id="projects">
            <div className="project__header">
                <h2 className="section__title">Projects</h2>
                <p className="section__subtitle">Showcasing my recent work and achievements</p>
                <div className="project__divider"></div>
            </div>

            <div className="project__container container">
                <div className="project__filters">
                    <button
                        className={`filter__btn ${activeCategory === 'all' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('all')}
                    >
                        <i className="bx bx-grid-alt"></i>
                        <span>All Projects</span>
                    </button>
                    <button
                        className={`filter__btn ${activeCategory === 'web' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('web')}
                    >
                        <i className="bx bx-globe"></i>
                        <span>Web</span>
                    </button>
                    <button
                        className={`filter__btn ${activeCategory === 'mobile' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('mobile')}
                    >
                        <i className="bx bx-mobile"></i>
                        <span>Mobile</span>
                    </button>
                    <button
                        className={`filter__btn ${activeCategory === 'backend' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('backend')}
                    >
                        <i className="bx bx-server"></i>
                        <span>Backend</span>
                    </button>
                </div>

                <div className={`project__grid ${isVisible ? 'visible' : ''}`}>
                    {filteredProjects.map((project, index) => (
                        <div key={project.id} className="project__card" style={{ animationDelay: `${index * 0.1}s` }}>
                            <div className="project__image-wrapper">
                                <img src={project.image} alt={project.title} className="project__img" />
                                <div className="project__overlay">
                                    <button className="project__view-btn" onClick={() => openModal(project)}>
                                        <i className="bx bx-show"></i>
                                        View Details
                                    </button>
                                </div>
                            </div>
                            <div className="project__content">
                                <div className="project__category-badge">{project.category}</div>
                                <h3 className="project__title">{project.title}</h3>
                                <p className="project__description">
                                    {project.description.substring(0, 120)}...
                                </p>
                                <div className="project__tech">
                                    {project.technologies.slice(0, 4).map((tech, idx) => (
                                        <span key={idx} className="tech__tag">{tech}</span>
                                    ))}
                                    {project.technologies.length > 4 && (
                                        <span className="tech__tag more">+{project.technologies.length - 4}</span>
                                    )}
                                </div>
                                <div className="project__actions">
                                    {project.demo && (
                                        <a href={project.demo} className="project__link" target="_blank" rel="noopener noreferrer">
                                            <i className="bx bx-link-external"></i> Live Demo
                                        </a>
                                    )}
                                    {project.repo && (
                                        <a href={project.repo} className="project__link" target="_blank" rel="noopener noreferrer">
                                            <i className="bx bxl-github"></i> Code
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {selectedProject && (
                <div className="project__modal" onClick={closeModal}>
                    <div className="modal__content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal__close" onClick={closeModal}>
                            <i className="bx bx-x"></i>
                        </button>
                        <div className="modal__image">
                            <img src={selectedProject.image} alt={selectedProject.title} />
                        </div>
                        <div className="modal__info">
                            <div className="modal__category">{selectedProject.category}</div>
                            <h2 className="modal__title">{selectedProject.title}</h2>
                            <p className="modal__description">{selectedProject.description}</p>
                            <div className="modal__technologies">
                                <h4>Technologies Used:</h4>
                                <div className="modal__tech-list">
                                    {selectedProject.technologies.map((tech, idx) => (
                                        <span key={idx} className="modal__tech-tag">{tech}</span>
                                    ))}
                                </div>
                            </div>
                            <div className="modal__links">
                                {selectedProject.demo && (
                                    <a href={selectedProject.demo} className="modal__link primary" target="_blank" rel="noopener noreferrer">
                                        <i className="bx bx-link-external"></i> View Live Demo
                                    </a>
                                )}
                                {selectedProject.repo && (
                                    <a href={selectedProject.repo} className="modal__link secondary" target="_blank" rel="noopener noreferrer">
                                        <i className="bx bxl-github"></i> View Source Code
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    )
}

export default Project;